import React from 'react';
import { Form, Table } from 'react-bootstrap';
import Select from 'react-select';
import { IoMdClose } from 'react-icons/io';

const ProductTableSales = ({
    rows,
    unitOptions,
    onRowChange,
    onRemoveRow,
    loadingPrices = {}
}) => {
    return (
        <div className="table-responsive mt-3">
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Part No.</th>
                        <th>HSN Code</th>
                        <th>Serial No.</th>
                        <th>MOC</th>
                        <th>Type</th>
                        <th>Size</th>
                        <th>Rating</th>
                        <th>class</th>
                        <th>Schedule</th>
                        <th>Certification</th>
                        <th>Quantity</th>
                        <th>unit of measurement</th>
                        <th>Unit Price (₹)</th>
                        <th>Amount (₹)</th>
                        <th>GST (%)</th>
                        <th>Total Amount (Incl. GST)</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <ProductRow
                            key={index}
                            row={row}
                            index={index}
                            unitOptions={unitOptions}
                            onRowChange={onRowChange}
                            onRemoveRow={onRemoveRow}
                            isLoading={loadingPrices[row.value]}
                        />
                    ))}
                </tbody>
            </Table>
        </div>
    );
};


const ProductRow = ({
    row,
    index,
    unitOptions,
    onRowChange,
    onRemoveRow,
    isLoading
}) => {
    return (
        <tr>
            <td>
                {row.description}
                <Form.Control
                    as="textarea"
                    rows={2}
                    value={row.productremarks}
                    onChange={(e) =>
                        onRowChange(index, "productremarks", e.target.value)
                    }
                    placeholder="Remarks"
                    className="remarkss"
                />
            </td>
            <td>{row.partno}</td>
            <td>{row.hsnsacno}</td>
            <td>{row.serialnumber}</td>

            {/* Editable Technical Fields */}
            <EditableField
                value={row.moc}
                onChange={(value) => onRowChange(index, "moc", value)}
                placeholder="Enter item moc"
            />
            <EditableField
                value={row.type}
                onChange={(value) => onRowChange(index, "type", value)}
                placeholder="Enter item type"
            />
            <EditableField
                value={row.size}
                onChange={(value) => onRowChange(index, "size", value)}
                placeholder="Enter item size"
            />
            <EditableField
                value={row.rating}
                onChange={(value) => onRowChange(index, "rating", value)}
                placeholder="Enter item rating"
            />
            <EditableField
                value={row.classes}
                onChange={(value) => onRowChange(index, "classes", value)}
                placeholder="Enter item class"
            />
            <EditableField
                value={row.schedule}
                onChange={(value) => onRowChange(index, "schedule", value)}
                placeholder="Enter item schedule"
            />
            <EditableField
                value={row.certification}
                onChange={(value) => onRowChange(index, "certification", value)}
                placeholder="Enter item certification"
            />

            {/* Quantity */}
            <td>
                <Form.Control
                    className='quantity'
                    type="number"
                    value={row.quantity}
                    onChange={(e) =>
                        onRowChange(index, "quantity", parseFloat(e.target.value))
                    }
                />
            </td>

            {/* UOM */}
            <td>
                <Select
                    value={unitOptions.find((opt) => opt.value === row.uom)}
                    options={unitOptions}
                    onChange={(selectedOption) =>
                        onRowChange(index, "uom", selectedOption.value)
                    }
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    className='uom'
                />
            </td>

            {/* Unit Price */}
            <td>
                <Form.Control
                    type="number"
                    step="0.01"
                    value={row.unitRateInr}
                    onChange={(e) =>
                        onRowChange(index, "unitRateInr", parseFloat(e.target.value))
                    }
                />
            </td>

            {/* Amount */}
            <td className="text-end">₹{row.amount?.toFixed(2)}</td>

            {/* GST */}
            <td>
                <Form.Control
                    type="number"
                    value={row.gstPercent}
                    onChange={(e) =>
                        onRowChange(index, "gstPercent", parseFloat(e.target.value))
                    }
                    className='gst'
                />
            </td>

            {/* Total Amount */}
            <td className="text-end">₹{row.totalinr?.toFixed(2)}</td>

            {/* Action - YAHAN FIX KARO */}
            <td className="text-center">
                <button
                    type="button"
                    className="button-70 btn-danger"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onRemoveRow(index);
                    }}
                >
                    <IoMdClose />
                </button>
            </td>
        </tr>
    );
};

const EditableField = ({ value, onChange, placeholder }) => (
    <td>
        <Form.Control
            className="remark"
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
        />
    </td>
);

export default ProductTableSales;